import { createFileRoute } from "@tanstack/react-router";

import { WorkspaceDashboardPage } from "#app/components/dashboards/workspace-dashboard-page";
import { withMemberModule } from "#app/components/permissions/require-permission";

/**
 * `/dashboards/$viewId` — a WORKSPACE-scoped dashboard, opened as its own
 * page under the Dashboards module. The sibling `my` segment is a static
 * route and wins over this dynamic one, so no view id can shadow it.
 */
function WorkspaceDashboardRoute() {
  const { viewId } = Route.useParams();
  return <WorkspaceDashboardPage key={viewId} viewId={viewId} />;
}

export const Route = createFileRoute("/(app)/$workspace/dashboards/$viewId")({
  // A member module: a Guest never reaches it (`ModuleTier`). The rail
  // omits the tile; the route denies for itself since the URL still resolves.
  component: withMemberModule(WorkspaceDashboardRoute),
});
